import { service, formService } from '@/data/index';
import config from '@/config/index';
/**
 * @function getLoginLogList 获取登录日志信息列表
 * @param data  参数对象{}
 * @returns {*}
 */

export function getLoginLogList(data) {
  return service.get('system/systemLog/list', data);
}
/**
 * @function getDirectorySetList 获取学校自定义字典信息列表
 * @param data  参数对象{}
 * @returns {*}
 */

export function getDirectorySetList(data) {
  return service.get('school/orgDictionaries/list', data);
}
/**
 * @function updateDirectoryStatus 修改学校自定义字典状态
 * @param data  参数对象{}
 * @returns {*}
 */

export function updateDirectoryStatus(data) {
  return service.post('school/orgDictionaries/enable', data);
}
/**
 * @function saveDirectoryInfo 新增学校自定义字典内容
 * @param data  参数对象{}
 * @returns {*}
 */

export function saveDirectoryInfo(data) {
  return service.post('school/orgDictionaries/save', data);
}
/**
 * @function getTermList 学校获取学期信息列表
 * @param data  参数对象{}
 * @returns {*}
 */

export function getTermList(data) {
  return service.get('org/termSetting/list', data);
}
/**
 * @function updateTermInfoBySchool 学校修改学期信息
 * @param data  参数对象{}
 * @returns {*}
 */

export function updateTermInfoBySchool(data) {
  return service.post('school/termSetting/definedTermTime', data);
}
/**
 * @function getTermNameToWeekList 获取当前所处学期，方便周期表信息获取时参数传递
 * @param data  参数对象{}
 * @returns {*}
 */

export function getTermNameToWeekList(data) {
  return service.post('school/termSetting/weekListTermName', data);
}
/**
 * @function getWeekList 获取周期表信息
 * @param data  参数对象{}
 * @returns {*}
 */

export function getWeekList(data) {
  return service.post('school/termSetting/weekList', data);
}
/**
 * @function updateWeekInfoBySchool 修改教学周期月份
 * @param data  参数对象{}
 * @returns {*}
 */

export function updateWeekInfoBySchool(data) {
  return service.post('school/termSetting/updateWeekList', data);
}
/**
 * @function schoolInfo 获取学校基础信息
 * @returns {*}
 */

export function schoolInfo() {
  return service.get('school/school/get');
}
/**
 * @function saveSchoolInfo 保存学校信息
 * @param data  参数对象{}
 * @returns {*}
 */

export function saveSchoolInfo(data) {
  return service.post('school/school/save', data);
}
/*
 *  单位信息接口部分
 **/

/**
 * 省查看教育局
 * @param data
 */

export function getEducationDetailInfo(data) {
  return service.post('org/education/educationInfoByCode', data);
}
/**
 * 省查看学校信息
 * @param data
 */

export function getSchoolDetailInfo(data) {
  return service.get('school/school/getSchoolByCode', data);
}
/**
 * 保存单位信息
 * @param data
 */

export function editUnitInfo(data) {
  return service.post('org/education/save', data);
}
/**
 * 获取单位信息
 * @param data
 */

export function getOrgTreelist(data) {
  return service.get('org/orgTreeList', data);
}